import Vue from 'vue';
import VueRouter from 'vue-router';
import DefaultLayout from '../components/layout';
import AddressBook from '../layouts/addressBook';
import Billing from '../layouts/billing';
import BillOfLading from '../layouts/billoflading';
import Blank from '../layouts/blank';
import Bol from '../layouts/bol';
import ClientSsoLogin from '../layouts/client-sso-login/client-sso-login.vue';
import CompanyAccount from '../layouts/companyAccount';
import Credit from '../layouts/credit';
import CustomerSignup from '../layouts/customerSignup';
import Demo from '../layouts/demo';
import Demo2 from '../layouts/demo2';
import EstimatedQuote from '../layouts/estimatedQuote';
import GetQuote from '../layouts/getQuote';
import GetQuoteToLastMile from '../layouts/getQuoteToLastMile';
import Unis100Quote from '../layouts/getQuoteUnis100';
import Home from '../layouts/home';
import Invoices from '../layouts/invoices';
import Login from '../layouts/login';
import MessageCenter from '../layouts/messagecenter';
import MyAccount from '../layouts/myAccount';
import MyAccountEdit from '../layouts/myAccountEdit';
import MyCustomers from '../layouts/myCustomers';
import NewAddressBook from '../layouts/newAddressBook';
import NotFound from '../layouts/not-found';
import OrderReview from '../layouts/orderReview';
import PaymentList from '../layouts/paymentList';
import Quote from '../layouts/quote';
import QuoteList from '../layouts/quoteList';
import Resources from '../layouts/resources';
import ReviewPickupRequest from '../layouts/reviewPickupRequest';
import SavedProducts from '../layouts/savedProduct';
import SavedQuote from '../layouts/savedQuote';
import ScheduleAPickup from '../layouts/scheduleApickup';
import SchedulePickup from '../layouts/schedulePickup';
import SchedulePickupReview from '../layouts/schedulePickupReview';
import SchedulePickupShipment from '../layouts/schedulePickupShipment';
import Shipment from '../layouts/shipment';
import Shipments4Shippers from '../layouts/shipments-4-shippers';
import Shipments4ShippersDetails from '../layouts/shipments-4-shippers-details';
import Shipments4ShipmentView from '../layouts/shipments-4-shippers-shipment-view';
import ShipmentConfirmation from '../layouts/shipmentCconfirmation';
import ShipmentView from '../layouts/shipmentView';
import Tasks from '../layouts/tasks';
import Track from '../layouts/track';
import TrackShipmentGuest from '../layouts/trackShipmentGuest';
import TrackShipmentLoggedIn from '../layouts/trackShipmentLoggedIn';
import Tracking from '../layouts/tracking';
import UserProfile from '../layouts/userProfile';
import VerifyEmail from '../layouts/verifyEmail';
import ViewShipment from '../layouts/viewShipment';
import ClaimsAndDisputes from '../layouts/ClaimsAndDisputes/ClaimsAndDisputes.vue';
import store from '../store';

Vue.use(VueRouter);

const router = new VueRouter({
    routes: [
        {
            path: '',
            component: DefaultLayout,
            children: [
                {
                    path: '/',
                    redirect: { name: 'Login' },
                },

                {
                    path: '/login',
                    name: 'Login',
                    component: Login,
                },
                {
                    path: '/verifyEmail',
                    name: 'VerifyEmail',
                    component: VerifyEmail,
                },

                {
                    path: '/home',
                    name: 'Home',
                    component: Home,
                },
                {
                    path: '/blank',
                    name: 'Blank',
                    component: Blank,
                },
                {
                    path: '/getQuote',
                    name: 'GetQuote',
                    component: GetQuote,
                },
                {
                    path: '/quote/',
                    name: 'Quote',
                    component: Quote,
                },
                {
                    path: '/savedQuote',
                    name: 'SavedQuotes',
                    component: SavedQuote,
                },
                {
                    path: '/estimatedQuote',
                    name: 'estimatedQuote',
                    component: EstimatedQuote,
                },
                {
                    path: '/quoteList',
                    name: 'QuoteList',
                    component: QuoteList,
                },
                {
                    path: '/resources',
                    name: 'Resources',
                    component: Resources,
                },
                {
                    path: '/schedulePickup',
                    name: 'SchedulePickup',
                    component: SchedulePickup,
                },
                {
                    path: '/schedulePickup/Shipment',
                    name: 'SchedulePickupShipment',
                    component: SchedulePickupShipment,
                },
                {
                    path: '/schedulePickup/Review',
                    name: 'SchedulePickupReview',
                    component: SchedulePickupReview,
                },
                {
                    path: '/customerSignup',
                    name: 'Signup',
                    component: CustomerSignup,
                },
                {
                    path: '/demo',
                    name: 'Demo',
                    component: Demo,
                },
                {
                    path: '/demo2',
                    name: 'Demo2',
                    component: Demo2,
                },
                {
                    path: '/invoices',
                    name: 'Invoices',
                    component: Invoices,
                },
                {
                    path: '/viewShipment/:id',
                    name: 'ViewShipment',
                    component: ViewShipment,
                },
                {
                    path: '/scheduleApickup/:quoteId',
                    name: 'ScheduleApickup',
                    component: ScheduleAPickup,
                },
                {
                    path: '/reviewPickupRequest/:id',
                    name: 'ReviewPickupRequest',
                    component: ReviewPickupRequest,
                },
                {
                    path: '/shipmentCconfirmation/:id?/:quoteId',
                    name: 'ShipmentCconfirmation',
                    component: ShipmentConfirmation,
                },
                {
                    path: '/billoflading/:orderId',
                    name: 'Billoflading',
                    component: BillOfLading,
                },
                {
                    path: '/bol/:id',
                    name: 'Bol',
                    component: Bol,
                },
                {
                    path: '/track',
                    name: 'TrackShipment',
                    component: Track,
                },
                {
                    path: '/orderReview',
                    name: 'orderReview',
                    component: OrderReview,
                },
                {
                    path: '/myAccount',
                    name: 'myAccount',
                    component: MyAccount,
                },
                {
                    path: '/myCustomers',
                    name: 'myCustomers',
                    component: MyCustomers,
                },
                {
                    path: '/myAccount/edit',
                    name: 'myAccountEdit',
                    component: MyAccountEdit,
                },
                {
                    path: '/addressBook',
                    name: 'addressBook',
                    component: AddressBook,
                },
                {
                    path: '/messagecenter',
                    name: 'messageCenter',
                    component: MessageCenter,
                },
                {
                    path: '/lastMileQuote',
                    name: 'LastMileQuote',
                    component: GetQuoteToLastMile,
                },
                {
                    path: '/savedProducts',
                    name: 'SavedProducts',
                    component: SavedProducts,
                },
                {
                    path: '/unis100Quote',
                    name: 'Unis100Quote',
                    component: Unis100Quote,
                },
                {
                    path: '/newAddressBook',
                    name: 'newAddressBook',
                    component: NewAddressBook,
                },
                {
                    path: '/shipment',
                    name: 'shipment',
                    component: Shipment,
                },
                {
                    path: '/claimsAndDisputes',
                    name: 'claimsAndDisputes',
                    component: ClaimsAndDisputes,
                },
                {
                    path: '/trackShipmentLoggedIn',
                    name: 'trackShipmentLoggedIn',
                    component: TrackShipmentLoggedIn,
                },
                {
                    path: '/trackShipmentGuest',
                    name: 'TrackShipmentGuest',
                    component: TrackShipmentGuest,
                },
                {
                    path: '/tracking',
                    name: 'tracking',
                    component: Tracking,
                },
                {
                    path: '/userProfile',
                    name: 'UserProfile',
                    component: UserProfile,
                },
                {
                    path: '/credit',
                    name: 'Credit',
                    component: Credit,
                },
                {
                    path: '/paymentList',
                    name: 'PaymentList',
                    component: PaymentList,
                },
                {
                    path: '/shipmentView/:orderId/:from',
                    name: 'ShipmentView',
                    component: ShipmentView,
                },
                {
                    path: '/billing',
                    name: 'Billing',
                    component: Billing,
                },
                {
                    path: '/tasks',
                    name: 'Tasks',
                    component: Tasks,
                },
                {
                    path: '/companyAccount',
                    name: 'CompanyAccount',
                    component: CompanyAccount,
                },
                {
                    path: '/client-sso-login',
                    name: 'ClientSsoLogin',
                    component: ClientSsoLogin,
                },
            ],
        },

        {
            path: '/shipments-4-shippers',
            name: 'shipments-4-shippers',
            component: Shipments4Shippers,
        },

        {
            path: '/shipments-4-shippers/:orderId',
            name: 'shipments-4-shippers-order-details',
            component: Shipments4ShippersDetails,
        },

        {
            path: '/shipments-4-shippers/shipment-view/:orderId/:from',
            name: 'shipments-4-shippers-shipment-view',
            component: Shipments4ShipmentView,
        },

        {
            path: '*',
            component: NotFound,
        },
    ],
    mode: 'hash',
    linkActiveClass: 'active',
    // scroll to top
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
});

// 添加全局路由守卫
router.beforeEach((to, from, next) => {
    // 统一键名，确保从两种可能的键名中获取值
    const isClaimsAccess = localStorage.getItem('isClaimsAccess') === 'true' || 
                          localStorage.getItem('ClaimsAccess') === '1';
    const isSBCust = localStorage.getItem('isSBCust') === 'true';
    const isShipperOrConsignee = localStorage.getItem('IsShipperOrConsignee') == '1';
    const isSwitchToClientPortal = localStorage.getItem('switchToClientPortal') == '1';
    
    // 同时更新这两个键，保持一致性
    localStorage.setItem('isClaimsAccess', isClaimsAccess ? 'true' : 'false');
    localStorage.setItem('ClaimsAccess', isClaimsAccess ? '1' : '0');
    localStorage.setItem('isSBCust', isSBCust ? 'true' : 'false');

    // 定义一些路径常量
    const CLAIMS_PATH = '/claimsAndDisputes';
    const SHIPPER_PATH = '/shipments-4-shippers';
    
    // 检查路径是否是可以访问的Claims页面
    const isClaimsPage = to.path === CLAIMS_PATH;
    
    // 检查路径是否是可以访问的Shipper页面
    const isValidShipperPage = to.path === SHIPPER_PATH || 
                              to.path === '/pickupDashboard' || 
                              to.name === 'shipments-4-shippers-order-details' ||
                              to.name === 'shipments-4-shippers-shipment-view';

    // 优先级处理：Shipper/Consignee权限 > Claims访问权限
    // 首先检查是否是Shipper/Consignee
    if (isShipperOrConsignee && !isSwitchToClientPortal) {
        // 如果已经在有效的Shipper页面，则允许访问
        if (isValidShipperPage) {
            return next();
        }
        // 否则重定向到Shipper页面
        return next(SHIPPER_PATH);
    }
    
    // 其次检查Claims访问权限
    if (isClaimsAccess && isSBCust) {
        // 如果用户有Claims访问权限，并且已经在Claims页面，则允许访问
        if (isClaimsPage) {
            return next();
        }
        // 否则重定向到Claims页面
        return next(CLAIMS_PATH);
    }
    
    // 其他情况正常访问
    next();
});

export default router;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/router/index.ts